/*
 * This file is generated by icons/template.js
 */
const SvgChatBubble = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>
		<path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
	</svg>
);
SvgChatBubble.displayName = 'iconChatBubble';
export default SvgChatBubble;
